import { Link } from "react-router-dom"

export function RouteTabs({ label, items, activeKey }) {
  return (
    <nav className="ui-route-tabs" aria-label={label}>
      {items.map((item) => (
        <Link
          key={item.key}
          className={`ui-route-tabs__item${activeKey === item.key ? " is-active" : ""}`}
          to={item.to}
          aria-current={activeKey === item.key ? "page" : undefined}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
